<div class="checkboxGroup">
    <mm-radio-control [parentForm]="parentForm" [radioModel]="recipientModel"></mm-radio-control>
</div>
<div *ngIf="showEscrowOrTitleCompanyCheckbox" class="checkboxGroup" [formGroup]="parentForm">
    <input type="checkbox" formControlName="isEscrow" id="isEscrow" name="isEscrow" value="isEscrow"
        data-testid="wireRecipientEscrowCheckbox">
    <label for="isEscrow">Recipient is an escrow/title company</label>
</div>
  <mm-banners *ngIf="isEscrow$ | async" [bannerText]="[warningDescription]" [titleText]="warningTitle" [type]="'warning'"
          data-testid="wireRecipientEscrowWarning"></mm-banners>